import { render, staticRenderFns } from "./AddMediaToTest.vue?vue&type=template&id=ce89ee8e&scoped=true&"
import script from "./AddMediaToTest.vue?vue&type=script&lang=js&"
export * from "./AddMediaToTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce89ee8e",
  null
  
)

export default component.exports